import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/@shared';
import { TractorSupplyV1RoutingModule } from './tractorsupply.v1.routing.module';

@NgModule({
  declarations: [],
  imports: [
    SharedModule,
    TractorSupplyV1RoutingModule
  ]
})

export class TractorSupplyV1Module { }
